module.exports = __webpack_public_path__ + "img/search-grey.d8bab7d0.svg";